import { render } from "./PaginatedTables.vue?vue&type=template&id=3f6c04f7"
import script from "./PaginatedTables.vue?vue&type=script&lang=js"
export * from "./PaginatedTables.vue?vue&type=script&lang=js"

import "./PaginatedTables.vue?vue&type=style&index=0&id=3f6c04f7&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__